<div class="flex gap-3">
  <!-- Search Input and Filters -->
  <app-filters *appHasPermission="'get_all_order'" [filters]="filterStructure"></app-filters>
  <app-table-refresh class="mt-5" [tableKey]="'orders'"></app-table-refresh>
</div>
<!-- table skeleton loader -->
 @if (isFetchingOrderList$ | async) {
<div *appHasPermission="'get_all_order'" class="mt-[0.94rem]">
  <app-table-skeleton-loader></app-table-skeleton-loader>
</div>
}
<!--Table -->
@if (!(isFetchingOrderList$ | async)) {
<div
  class="mt-[0.94rem] rounded-lg border border-solid border-gray-200 bg-white"
  *appHasPermission="'get_all_order'"
  >
  <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
    <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
      <div
        class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg"
      >
        <table class="min-w-full leading-normal">
          <thead>
            <tr>
              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-600"
              >
                S/N
              </th>
              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-5 text-left text-xs font-semibold tracking-wider text-gray-600"
              >
                Date Created
              </th>
              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-5 text-left text-xs font-semibold tracking-wider text-gray-600"
              >
                User / Organisation
              </th>

              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-5 text-left text-xs font-semibold tracking-wider text-gray-600"
              >
                Order Type
              </th>

              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-5 text-left text-xs font-semibold tracking-wider text-gray-600"
              >
                Payment Source
              </th>

              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-5 text-left text-xs font-semibold tracking-wider text-gray-600"
              >
                Products
              </th>

              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-5 text-left text-xs font-semibold tracking-wider text-gray-600"
              >
                Amount
              </th>

              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-5 text-left text-xs font-semibold tracking-wider text-gray-600"
              >
                Status
              </th>
              <th
                scope="col"
                class="relative border-b-2 border-gray-200 bg-gray-100 py-3.5 pl-3 pr-4 sm:pr-6"
              >
                <span class="sr-only">Edit</span>
              </th>
            </tr>
          </thead>

          <tbody>
            <!-- @if (ordersList.length < 1) {
              <tr>
                <td span="10">No orders found!</td>
              </tr>
            } @else {
              @for (order of ordersList; track order.order_id; let i = $index) {
               
              } @empty {
                Empty list of users
              }
            } -->

            <ng-container>
            @if ((orderList$ | async).length > 0) {
            @for (
                order of orderList$ | async;
                track order.id;
                let i = $index
              ) {
              <tr
                class="border-b border-gray-200 bg-white"
              >
                <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                  <p>{{ i + 1 }}</p>
                </td>
                <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                  <p class="whitespace-no-wrap text-gray-900">
                    {{ order.created_at | date: 'medium' }}
                  </p>
                </td>

                <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                  @if (order.account?.account_type === 'corporate') {
                    <p class="whitespace-no-wrap text-gray-900">
                      {{
                        (order.account?.corporate_kyc?.name | titlecase) || '—'
                      }}
                    </p>
                  } @else {
                    <p class="whitespace-no-wrap text-gray-900">
                      {{ order.account.user_profile?.first_name | titlecase }}
                      {{ order.account.user_profile?.middle_name | titlecase }}
                      {{ order.account.user_profile?.last_name | uppercase }}
                    </p>
                  }
                </td>

                <td
                  class="sm:pmd:py-4 border-b border-gray-200 bg-white px-2 py-2 text-xs sm:px-3 sm:text-sm md:px-4 lg:px-5"
                >
                  <span
                    class="relative inline-block px-2 py-1 font-semibold leading-tight text-green-900 sm:px-2"
                  >
                    <span
                      aria-hidden
                      class="absolute inset-0 {{
                        order.type === 'invest'
                          ? 'bg-green-200'
                          : 'bg-orange-300'
                      }} opacity-50 rounded-full"
                    ></span>
                    <span
                      class="relative flex  {{
                        order.type === 'invest'
                          ? 'text-[#027A48]'
                          : 'text-orange-700'
                      }} sm:text-[11px]"
                    >
                      {{ order.type | uppercase }}</span
                    >
                  </span>
                </td>

                <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                  <p class="whitespace-no-wrap text-gray-900">
                    {{ order.payment_source | uppercase }}
                  </p>
                </td>

                <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                  <p class="whitespace-no-wrap text-gray-900">
                    {{
                    
                      getProductName(order)
                    }}
                  </p>
                </td>

                <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                  <p class="whitespace-no-wrap text-gray-900">
                    {{ order.currency === 'USD' ? '$' : '₦' }}{{ order.amount / 100 | number: '1.2-2' }}
                  </p>
                </td>

                <td
                  class="sm:pmd:py-4 border-b border-gray-200 bg-white px-2 py-2 text-xs sm:px-3 sm:text-sm md:px-4 lg:px-5"
                >
                  <app-status-badge [status]="order.status"></app-status-badge>
                </td>

                <td
                  class="title relative whitespace-nowrap border-b py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6"
                >
                  <div
                    class="relative inline-block w-fit cursor-pointer border-gray-200 bg-white text-left"
                  >
                    <app-dropdown
                      [id]="order.id"
                      [actionList]="initDropdownList(order)"
                    >
                    </app-dropdown>
                  </div>
                </td>
              </tr>
            }
          } @else {
            <tr>
              <td span="10">No orders found!</td>
            </tr>
          }
            </ng-container>
            <ng-template #noOrders>
              <tr>
                <td colspan="6">No Orders found!</td>
              </tr>
            </ng-template>
          </tbody>
        </table>
        <app-table-navigator
          *ngIf="totalCount$ | async as totalCount"
          [total]="totalCount"
          (onNavigation)="navigate($event)"
        ></app-table-navigator>
      </div>
    </div>
  </div>
</div>
}
